// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-menus-info-menu----info-menu-module---list---3sfhF","item":"src-components-menus-info-menu----info-menu-module---item---dgVI6","link":"src-components-menus-info-menu----info-menu-module---link---idaag"};


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/info-menu/info-menu.module.css
// module id = 167
// module chunks = 35783957827783 114276838955818